import React from "react";
import { Navigate } from "react-router-dom";

export default function PrivateRoute({ children }) {
  const raw = typeof window !== "undefined"
    ? localStorage.getItem("adminAuth")
    : null;

  let valid = false;
  try {
    if (raw) {
      const parsed = JSON.parse(raw);
      valid = parsed?.v === true && Date.now() < parsed?.exp;
    }
  } catch { /* ignore */ }

  return valid ? children : <Navigate to="/login" replace />;
}
